import React from 'react';
import AlarmModal from 'src/components/Template/AlarmModal';
import AutoModalSlide from 'src/components/Template/AutoModalSlide';
import BasicFullImage from 'src/components/Template/BasicFullImage';
import BottomSheetImage from 'src/components/Template/BottomSheetImage';
import BottomSheetSlide from 'src/components/Template/BottomSheetSlide';
import CouponBottomSheet from 'src/components/Template/CouponBottomSheet';
import BasicFullCountdown from 'src/components/Template/BasicFullCountdown';
import FullDualImage from 'src/components/Template/FullDualImage';
import ImageBottomSheet from 'src/components/Template/ImageBottomSheet';
import ListModal from 'src/components/Template/ListModal';
import ModalSlide from 'src/components/Template/ModalSlide';
import RadiusFullCountdown from 'src/components/Template/RadiusFullCountdown';
import RadiusModalSlide from 'src/components/Template/RadiusModalSlide';
import SimpleModalSlide from 'src/components/Template/SimpleModalSlide';
import SlideFullImage from 'src/components/Template/SlideFullImage';
import SlideModalImage from 'src/components/Template/SlideModalImage';
import SlideModalRound from 'src/components/Template/SlideModalRound';
import TransparentBottomSheet from 'src/components/Template/TransparentBottomSheet';

import BasicFullCountdownHTML from 'src/components/TemplateHTML/BasicFullCountdownHTML';
import BottomSheetImageHTML from 'src/components/TemplateHTML/BottomSheetImageHTML';
import RadiusModalSlideHTML from 'src/components/TemplateHTML/RadiusModalSlideHTML';
import FullDualImageHTML from 'src/components/TemplateHTML/FullDualImageHTML';

import SimpleModalSlideHTML from 'src/components/TemplateHTML/SimpleModalSlideHTML';
import BottomSheetSlideHTML from 'src/components/TemplateHTML/BottomSheetSlideHTML';

import BasicFullImageHTML from 'src/components/TemplateHTML/BasicFullImageHTML';
import RadiusFullCountdownHTML from 'src/components/TemplateHTML/RadiusFullCountdownHTML';
import ModalSlideHTML from 'src/components/TemplateHTML/ModalSlideHTML';
import SlideModalRoundHTML from 'src/components/TemplateHTML/SlideModalRoundHTML';

import SlideFullImageHTML from 'src/components/TemplateHTML/SlideFullImageHTML';
import SlideModalImageHTML from 'src/components/TemplateHTML/SlideModalImageHTML';
import AutoModalSlideHTML from 'src/components/TemplateHTML/AutoModalSlideHTML';
import CouponBottomSheetHTML from 'src/components/TemplateHTML/CouponBottomSheetHTML';
import ImageBottomSheetHTML from 'src/components/TemplateHTML/ImageBottomSheetHTML';
import ListModalHTML from 'src/components/TemplateHTML/ListModalHTML';
import AlarmModalHTML from 'src/components/TemplateHTML/AlarmModalHTML';

import BottomSheetImageTracking from 'src/components/TemplateTracking/BottomSheetImageTracking';
import BasicFullCountdownTracking from 'src/components/TemplateTracking/BasicFullCountdownTracking';
import RadiusModalSlideTracking from 'src/components/TemplateTracking/RadiusModalSlideTracking';
import FullDualImageTracking from 'src/components/TemplateTracking/FullDualImageTracking';
import ModalSlideTracking from 'src/components/TemplateTracking/ModalSlideTracking';
import SlideModalRoundTracking from 'src/components/TemplateTracking/SlideModalRoundTracking';
import SimpleModalSlideTracking from 'src/components/TemplateTracking/SimpleModalSlideTracking';
import BottomSheetSlideTracking from 'src/components/TemplateTracking/BottomSheetSlideTracking';
import BasicFullImageTracking from 'src/components/TemplateTracking/BasicFullImageTracking';
import RadiusFullCountdownTracking from 'src/components/TemplateTracking/RadiusFullCountdownTracking';
import SlideFullImageTracking from 'src/components/TemplateTracking/SlideFullImageTracking';
import SlideModalImageTracking from 'src/components/TemplateTracking/SlideModalImageTracking';
import AutoModalSlideTracking from 'src/components/TemplateTracking/AutoModalSlideTracking';
import CouponBottomSheetTracking from 'src/components/TemplateTracking/CouponBottomSheetTracking';
import ImageBottomSheetTracking from 'src/components/TemplateTracking/ImageBottomSheetTracking';
import ListModalTracking from 'src/components/TemplateTracking/ListModalTracking';
import AlarmModalTracking from 'src/components/TemplateTracking/AlarmModalTracking';
import SimpleModalHTML from 'src/components/TemplateHTML/SimpleModalHTML';
import SimpleModal from 'src/components/Template/SimpleModal';
import SimpleModalTracking from 'src/components/TemplateTracking/SimpleModalTracking';
import MultipleChoiceSurveyTracking from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyTracking';
import MultipleChoiceSurvey from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyView';
import MultipleChoiceSurveyHTML from 'src/components/templates/MultipleChoiceSurvey/MultipleChoiceSurveyHTML';
import ShortAnswerSurveyHTML from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyHTML';
import ShortAnswerSurveyTracking from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyTracking';
import RatingAnswerSurvey from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyView';
import RatingAnswerSurveyHTML from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyHTML';
import RatingAnswerSurveyTracking from 'src/components/templates/RatingAnswerSurvey/RatingAnswerSurveyTracking';
import { ShortAnswerSurveyStyles } from 'src/components/templates/ShortAnswerSurvey/initStyles';
import { MultipleChoiceSurveyStyles } from 'src/components/templates/MultipleChoiceSurvey/initStyles';
import { RatingAnswerSurveyStyles } from 'src/components/templates/RatingAnswerSurvey/initStyles';
import ShortAnswerSurveyView from 'src/components/templates/ShortAnswerSurvey/ShortAnswerSurveyView';

import AutoSquareSlide from 'src/components/Template/AutoSquareSlide';
import AutoSquareSlideHTML from 'src/components/TemplateHTML/AutoSquareSlideHTML';
import AutoSquareSlideTracking from 'src/components/TemplateTracking/AutoSquareSlideTracking';
import CarouselSlideModalTracking from 'src/components/TemplateTracking/CarouselSlideModalTracking';
import CarouselSlideModalHTML from 'src/components/TemplateHTML/CarouselSlideModalHTML';
import CarouselSlideModal from 'src/components/Template/CarouselSlideModal';
import SimpleIconModal from 'src/components/Template/SimpleIconModal';
import SimpleIconModalHTML from 'src/components/TemplateHTML/SimpleIconModalHTML';
import SimpleIconModalTracking from 'src/components/TemplateTracking/SimpleIconModalTracking';
import ChoiceButtonModalHTML from 'src/components/TemplateHTML/ChoiceButtonModalHTML';
import ChoiceButtonModalTracking from 'src/components/TemplateTracking/ChoiceButtonModalTracking';
import ChoiceButtonModal from 'src/components/Template/ChoiceButtonModal';
import BottomSlideUp from 'src/components/Template/BottomSlideUp';
import BottomSlideUpHTML from 'src/components/TemplateHTML/BottomSlideUpHTML';
import BottomSlideUpTracking from 'src/components/TemplateTracking/BottomSlideUpTracking';
import TransparentBottomSheetHTML from 'src/components/TemplateHTML/TransparentBottomSheetHTML';
import TransparentBottomSheetTracking from 'src/components/TemplateTracking/TransparentBottomSheetTracking';
import SimpleCardModal from 'src/components/Template/SimpleCardModal';
import SimpleCardModalHTML from 'src/components/TemplateHTML/SimpleCardModalHTML';
import SimpleCardModalTracking from 'src/components/TemplateTracking/SimpleCardModalTracking';
import FloatingBottomSheet from 'src/components/Template/FloatingBottomSheet';
import FloatingBottomSheetHTML from 'src/components/TemplateHTML/FloatingBottomSheetHTML';
import FloatingBottomSheetTracking from 'src/components/TemplateTracking/FloatingBottomSheetTracking';
import CardModal from 'src/components/Template/CardModal';
import CardModalHTML from 'src/components/TemplateHTML/CardModalHTML';
import CardModalTracking from 'src/components/TemplateTracking/CardModalTracking';
import BasicBottomSheet from 'src/components/Template/BasicBottomSheet';
import BasicBottomSheetHTML from 'src/components/TemplateHTML/BasicBottomSheetHTML';
import BasicBottomSheetTracking from 'src/components/TemplateTracking/BasicBottomSheetTracking';
import ChoiceOptionImage from 'src/components/Template/ChoiceOptionImage';
import ChoiceOptionImageHTML from 'src/components/TemplateHTML/ChoiceOptionImageHTML';
import ChoiceOptionImageTracking from 'src/components/TemplateTracking/ChoiceOptionImageTracking';
import BasicScratchModal from 'src/components/Template/BasicScratchModal';
import BasicScratchModalHTML from 'src/components/TemplateHTML/BasicScratchModalHTML';
import BasicScratchModalTracking from 'src/components/TemplateTracking/BasicScratchModalTracking';
import BasicFullRoulette from 'src/components/Template/BasicFullRoulette';
import BasicFullRouletteHTML from 'src/components/TemplateHTML/BasicFullRouletteHTML';
import BasicFullRouletteTracking from 'src/components/TemplateTracking/BasicFullRouletteTracking';

export const GAMIFICATION_TEMPLATES = [
  'BASIC FULL ROULETTE',
  'BASIC SCRATCH MODAL'
];

export const TEMPLATES_VIEW: any = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdown />,
  'BOTTOM SHEET IMAGE': <BottomSheetImage />,
  'RADIUS MODAL SLIDE': <RadiusModalSlide />,
  'FULL DUAL IMAGE': <FullDualImage />,

  'MODAL SLIDE': <ModalSlide />,
  'SLIDE MODAL ROUND': <SlideModalRound />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlide />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlide />,

  'BASIC FULL IMAGE': <BasicFullImage />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdown />,
  'SIMPLE MODAL': <SimpleModal />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurvey />,

  'SLIDE FULL IMAGE': <SlideFullImage />,
  'SLIDE MODAL IMAGE': <SlideModalImage />,
  'AUTO MODAL SLIDE': <AutoModalSlide />,
  'COUPON BOTTOM SHEET': <CouponBottomSheet />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyView />,
  'RATING ANSWER SURVEY': <RatingAnswerSurvey />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheet />,
  'LIST MODAL': <ListModal />,
  'ALARM MODAL': <AlarmModal />,

  'AUTO SQUARE SLIDE': <AutoSquareSlide />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModal />,
  'SIMPLE ICON MODAL': <SimpleIconModal />,
  'CHOICE BUTTON MODAL': <ChoiceButtonModal />,
  'BOTTOM SLIDE UP': <BottomSlideUp />,
  'TRANSPARENT BOTTOM SHEET': <TransparentBottomSheet />,
  'SIMPLE CARD MODAL': <SimpleCardModal />,
  'FLOATING BOTTOM SHEET': <FloatingBottomSheet />,
  'CARD MODAL': <CardModal />,
  'BASIC BOTTOM SHEET': <BasicBottomSheet />,
  'CHOICE OPTION IMAGE': <ChoiceOptionImage />,
  'BASIC SCRATCH MODAL': <BasicScratchModal />,
  'BASIC FULL ROULETTE': <BasicFullRoulette />
};

export const TEMPLATES_HTML = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdownHTML />,
  'BOTTOM SHEET IMAGE': <BottomSheetImageHTML />,
  'RADIUS MODAL SLIDE': <RadiusModalSlideHTML />,
  'FULL DUAL IMAGE': <FullDualImageHTML />,

  'MODAL SLIDE': <ModalSlideHTML />,
  'SLIDE MODAL ROUND': <SlideModalRoundHTML />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlideHTML />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlideHTML />,

  'BASIC FULL IMAGE': <BasicFullImageHTML />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdownHTML />,
  'SIMPLE MODAL': <SimpleModalHTML />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurveyHTML />,

  'SLIDE FULL IMAGE': <SlideFullImageHTML />,
  'SLIDE MODAL IMAGE': <SlideModalImageHTML />,
  'AUTO MODAL SLIDE': <AutoModalSlideHTML />,
  'COUPON BOTTOM SHEET': <CouponBottomSheetHTML />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyHTML />,
  'RATING ANSWER SURVEY': <RatingAnswerSurveyHTML />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheetHTML />,
  'LIST MODAL': <ListModalHTML />,
  'ALARM MODAL': <AlarmModalHTML />,

  'AUTO SQUARE SLIDE': <AutoSquareSlideHTML />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModalHTML />,
  'SIMPLE ICON MODAL': <SimpleIconModalHTML />,
  'CHOICE BUTTON MODAL': <ChoiceButtonModalHTML />,
  'BOTTOM SLIDE UP': <BottomSlideUpHTML />,
  'TRANSPARENT BOTTOM SHEET': <TransparentBottomSheetHTML />,
  'SIMPLE CARD MODAL': <SimpleCardModalHTML />,
  'FLOATING BOTTOM SHEET': <FloatingBottomSheetHTML />,
  'CARD MODAL': <CardModalHTML />,
  'BASIC BOTTOM SHEET': <BasicBottomSheetHTML />,
  'CHOICE OPTION IMAGE': <ChoiceOptionImageHTML />,
  'BASIC SCRATCH MODAL': <BasicScratchModalHTML />,
  'BASIC FULL ROULETTE': <BasicFullRouletteHTML />
};

export const TEMPLATES_TRACKING: any = {
  'BASIC FULL COUNTDOWN': <BasicFullCountdownTracking />,
  'BOTTOM SHEET IMAGE': <BottomSheetImageTracking />,
  'RADIUS MODAL SLIDE': <RadiusModalSlideTracking />,
  'FULL DUAL IMAGE': <FullDualImageTracking />,

  'MODAL SLIDE': <ModalSlideTracking />,
  'SLIDE MODAL ROUND': <SlideModalRoundTracking />,
  'SIMPLE MODAL SLIDE': <SimpleModalSlideTracking />,
  'BOTTOM SHEET SLIDE': <BottomSheetSlideTracking />,

  'BASIC FULL IMAGE': <BasicFullImageTracking />,
  'RADIUS FULL COUNTDOWN': <RadiusFullCountdownTracking />,
  'SIMPLE MODAL': <SimpleModalTracking />,
  'MULTIPLE CHOICE SURVEY': <MultipleChoiceSurveyTracking />,

  'SLIDE FULL IMAGE': <SlideFullImageTracking />,
  'SLIDE MODAL IMAGE': <SlideModalImageTracking />,
  'AUTO MODAL SLIDE': <AutoModalSlideTracking />,
  'COUPON BOTTOM SHEET': <CouponBottomSheetTracking />,

  'SHORT ANSWER SURVEY': <ShortAnswerSurveyTracking />,
  'RATING ANSWER SURVEY': <RatingAnswerSurveyTracking />,
  'IMAGE BOTTOM SHEET': <ImageBottomSheetTracking />,
  'LIST MODAL': <ListModalTracking />,
  'ALARM MODAL': <AlarmModalTracking />,

  'AUTO SQUARE SLIDE': <AutoSquareSlideTracking />,
  'CAROUSEL SLIDE MODAL': <CarouselSlideModalTracking />,
  'SIMPLE ICON MODAL': <SimpleIconModalTracking />,
  'CHOICE BUTTON MODAL': <ChoiceButtonModalTracking />,
  'BOTTOM SLIDE UP': <BottomSlideUpTracking />,
  'TRANSPARENT BOTTOM SHEET': <TransparentBottomSheetTracking />,
  'SIMPLE CARD MODAL': <SimpleCardModalTracking />,
  'FLOATING BOTTOM SHEET': <FloatingBottomSheetTracking />,
  'CARD MODAL': <CardModalTracking />,
  'BASIC BOTTOM SHEET': <BasicBottomSheetTracking />,
  'CHOICE OPTION IMAGE': <ChoiceOptionImageTracking />,
  'BASIC SCRATCH MODAL': <BasicScratchModalTracking />,
  'BASIC FULL ROULETTE': <BasicFullRouletteTracking />
};

export const TEMPLATES_STYLE = template => {
  const STYLE = {
    'MULTIPLE CHOICE SURVEY': MultipleChoiceSurveyStyles(),
    'SHORT ANSWER SURVEY': ShortAnswerSurveyStyles(),
    'RATING ANSWER SURVEY': RatingAnswerSurveyStyles()
  };

  return STYLE[template];
};
